export const appConstants = {
  signingRequestsCheckTimeout: 3000,

  signingRequestId: "signing_request_id",

  nordicMarkets: ["de"],
};